module.exports = __webpack_public_path__ + "img/vol06_character_thumb02.9e477461.png";